<template>
    <div class="modal fade" id="edit_person_modal" tabindex="-1">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $lang('Edytuj osobę') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12 form-group">
                            <input type="checkbox" id="edit_active" name="active" v-model="editParams.active">
                            <label for="edit_active">{{ $lang('Aktywny') }}</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-md-6 form-group">
                            <label for="edit_name">{{ $lang('Imię ') }}<span
                                class="text-red">{{ $lang('(wymagane)') }}</span></label>
                            <input type="text" class="form-control" name="forename" id="edit_name"
                                   v-model="editParams.forename" :placeholder="$lang('Imię')">
                            <validation-errors :errors="validationErrors" :field="'forename'"></validation-errors>
                        </div>

                        <div class="col-12 col-md-6 form-group">
                            <label for="edit_surname">{{ $lang('Nazwisko ') }}<span
                                class="text-red">{{ $lang('(wymagane)') }}</span></label>
                            <input type="text" class="form-control" name="surname" id="edit_surname"
                                   v-model="editParams.surname" :placeholder="$lang('Nazwisko')">
                            <validation-errors :errors="validationErrors" :field="'surname'"></validation-errors>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-6 form-group">
                            <label for="edit_email">{{ $lang('E-mail ') }}<span
                                class="text-red">{{ $lang('(wymagane)') }}</span></label>
                            <div class="input-group mb-2">
                                <div class="input-group-prepend">
                                    <div class="bg-icon"><i class="fa fa-envelope-o" aria-hidden="true"></i></div>
                                </div>
                                <input type="text" class="form-control" id="edit_email" name="email"
                                       v-model="editParams.email" :placeholder="$lang('E-mail')">
                            </div>
                            <validation-errors :errors="validationErrors" :field="'email'"></validation-errors>
                            <p v-if="showWarningSbsEmail">
                                <small class="text-red">
                                    {{
                                        $lang('Uwaga! Zmiana adresu email osoby z SBS może mieć wpływ na integrację z systemem Jira\n')
                                    }}
                                </small>
                            </p>
                        </div>

                        <div class="col-12 col-md-6 form-group">
                            <label for="edit_phone_number">{{ $lang('Telefon ') }}</label>
                            <div class="input-group mb-2">
                                <div class="input-group-prepend">
                                    <div class="bg-icon"><i class="fa fa-phone" aria-hidden="true"></i></div>
                                </div>
                                <input type="text" class="form-control" id="edit_phone_number"
                                       v-model="editParams.phone" name="phone_number">
                            </div>
                            <validation-errors :errors="validationErrors" :field="'phone_number'"></validation-errors>
                        </div>

                        <div class="col-12 col-md-6 form-group" v-if="auth_type === 'people'">
                            <label for="edit_login">{{ $lang('Login ') }}<span
                                class="text-red">{{ $lang('(wymagane)') }}</span></label>
                            <div class="input-group mb-2">
                                <div class="input-group-prepend">
                                    <div class="bg-icon"><i class="fa fa-user-circle" aria-hidden="true"></i></div>
                                </div>
                                <input type="text" class="form-control" id="edit_login"
                                       v-model="editParams.login" name="login">
                            </div>
                            <validation-errors :errors="validationErrors" :field="'login'"></validation-errors>
                        </div>
                        <div class="col-12 col-md-6 form-group" v-if="auth_type === 'people'">
                            <label for="edit_password">{{ $lang('Hasło ') }}</label>
                            <div class="input-group mb-2">
                                <div class="input-group-prepend position-relative">
                                    <div class="bg-icon"><i class="fa fa-lock" aria-hidden="true"></i></div>
                                </div>
                                <eye-password></eye-password>
                                <input type="password" class="form-control" id="edit_password"
                                       v-model="editParams.password" name="password">
                                <i id="eye"
                                   style="position: absolute; right: 10px; top: 10px"
                                   class="fa fa-eye" aria-hidden="true"></i>
                            </div>
                            <validation-errors :errors="validationErrors" :field="'password'"></validation-errors>
                        </div>
                        <div class="col-12 form-group" v-if="current_project !== 'QUATRA' && editParams.library_id===sbs_id">
                            <label for="edit_jira_username">{{ $lang('User JIRA') }}<span
                                class="text-red">{{ $lang('(wymagane)') }}</span></label>
                            <input type="text" class="form-control" id="edit_jira_username"
                                   name="jira_username"
                                   v-model="editParams.jira_username" :placeholder="$lang('User JIRA')">
                            <validation-errors :errors="validationErrors" :field="'jira_username'"></validation-errors>
                            <p v-if="showWarningSbsUsername">
                                <small class="text-red">
                                    {{
                                        $lang('Uwaga! Zmiana wartości może mieć wpływ na integrację z systemem Jira\n')
                                    }}
                                </small>
                            </p>
                        </div>
                        <div class="col-12 row form-group" id="checkboxes" v-if="editParams.library_id===sbs_id">
                            <div class="col-4 mt-3">
                                <input type="checkbox" id="consultant" name="consultant"
                                       :checked="person.consultant == true" v-model="editParams.consultant">
                                <label for="consultant">{{ $lang('Konsultant') }}</label>
                            </div>

                            <div class="col-4 mt-3" v-if="current_project === 'PROLIB' || current_project === 'QUATRA'">
                                <input type="checkbox" id="programmer" name="programmer"
                                       :checked="person.programmer == true" v-model="editParams.programmer">
                                <label for="programmer">{{ $lang('Programista') }}</label>
                            </div>

                            <div class="col-4 mt-3" v-if="current_project === 'PROLIB'">
                                <input type="checkbox" id="installation" name="installation"
                                       :checked="person.installation == true" v-model="editParams.installation">
                                <label for="installation">{{ $lang('Instalator') }}</label>
                            </div>

                            <div class="col-4 mt-3" v-if="current_project === 'QUATRA'">
                                <input type="checkbox" id="designer" name="designer"
                                       :checked="person.designer == true" v-model="editParams.designer">
                                <label for="designer">{{ $lang('Projektant') }}</label>
                            </div>

                            <div class="col-12 mt-3" v-if="current_project === 'PROLIB' && (editParams.consultant || editParams.installation)">
                                <input type="checkbox" id="to_contact" name="to_contact"
                                       :checked="person.to_contact" v-model="editParams.to_contact">
                                <label for="to_contact">{{ $lang('Kontakt na stronie') }}</label>
                            </div>
                        </div>

                        <div class="col-12 form-group" v-if="editParams.library_id !== sbs_id || current_project === 'ORACLE'">
                            <label for="role_id">{{ $lang('Rola ') }}<span
                                class="text-red">{{ $lang('(wymagane)') }}</span></label>
                            <select id="role_id" name="role_id" class="form-control"
                                    v-model="editParams.role_id"
                            >
                                <option v-for="role in rolesToChoose" :value="role.id">{{ role.name }}</option>
                            </select>
                            <validation-errors :errors="validationErrors" :field="'role_id'"></validation-errors>
                        </div>
                    </div>
                    <div class="row form-group" v-if="editParams.library_id === sbs_id && current_project === 'PROLIB'">
                        <div class="col-md-3 col-6">
                            <add-image-component
                                :image="editParams.photo"
                                :route_add_image="upload_image_route"
                                :route_delete_image="delete_image_route"
                                :add_image_label="$lang('Dodaj zdjęcie')"
                                :delete_image_label="$lang('Usuń zdjęcie')"
                                :component_name="personImageComponentName"
                                :in_modal="true"
                            ></add-image-component>
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">
                        {{ $lang('Zamknij') }}
                    </button>
                    <button :key="'person_edit_button'" @click="edit" type="button" class="btn btn-primary" :disabled="!valid">
                        {{ $lang('Zapisz') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ShowNotification from "../../mixins/show-notification";
import AddImageComponent from "../add-image-component.vue";
import {EventBus} from "../../mixins/event-bus";

export default {
    name: 'person-edit-modal',
    components: {AddImageComponent},
    mixins: [ShowNotification],
    props: [
        'edit_route',
        'person',
        'sbs_id',
        'check_email_route',
        'upload_image_route',
        'delete_image_route',
        'roles',
        'admin_roles',
        'customer_roles',
        'current_project',
        'auth_type'
    ],
    data() {
        return {
            editParams: {
                forename: (this.person != null ? this.person.name : ''),
                surname: (this.person != null ? this.person.surname : ''),
                email: (this.person != null ? this.person.email : ''),
                jira_username: (this.person != null ? this.person.jira_username : ''),
                phone: (this.person != null ? this.person.phone : ''),
                consultant: (this.person != null ? this.person.consultant : ''),
                programmer: (this.person != null ? this.person.programmer : ''),
                installation: (this.person != null ? this.person.installation : ''),
                designer: (this.person != null ? this.person.designer : ''),
                to_contact: (this.person != null ? this.person.to_contact : ''),
                active: (this.person != null ? this.person.active : ''),
                library_id: (this.person != null ? this.person.library_id : ''),
                id: (this.person != null ? this.person.id : ''),
                role_id: (this.person != null ? this.person.role_id : ''),
                login: (this.person != null ? this.person.login : ''),
                password: '',
                photo: (this.person != null ? this.person.photo : null),
            },
            showWarningSbsEmail: false,
            showWarningSbsUsername: false,
            rolesToChoose: [],
            validationErrors: [],
            editable: true,
            personImageComponentName: 'edit_person_image_component',
        }
    },
    created() {
        this.listenForUploadImageSuccess();
        this.listenForDeleteImageSuccess();
    },
    computed: {
        valid() {
            if (this.person && this.person.email !== '' && this.person.email !== this.editParams.email && this.person.library_id === this.sbs_id) {
                this.showWarningSbsEmail = (this.current_project === 'QUATRA');
            } else {
                this.showWarningSbsEmail = false;
            }
            if (this.person && this.person.jira_username !== '' && this.person.jira_username !== this.editParams.jira_username && this.person.library_id === this.sbs_id) {
                this.showWarningSbsUsername = true;
            } else {
                this.showWarningSbsUsername = false;
            }
            return this.editParams.forename !== '' && this.editParams.surname !== '-' && this.editParams.email !== ''
                && (this.current_project === 'ORACLE' || (this.editParams.jira_username !== '' || this.person.library_id !== this.sbs_id))
                && (this.current_project !== 'ORACLE' || (this.editParams.role_id));
        }
    },
    methods: {
        edit() {
            if (this.editable) {
                this.editable = false;

                const self = this;
                self.validationErrors = [];
                axios.post(this.edit_route + '/' + this.editParams.id, self.editParams)
                     .then(response => {
                         if (response.data.save) {
                             self.$parent.generate(this.$parent.pagination.current_page);
                             self.showNotification('success', 'Pomyślnie edytowano osobę!');
                             jQuery('#edit_person_modal').modal('hide');
                         } else {
                             self.showNotification('error', 'Nie udało się edytować osoby!');
                         }
                     })
                     .catch(function (error) {
                         if (error.response.status === 422) {
                             self.validationErrors = error.response.data.errors;
                         }
                         self.showNotification('error', 'Nie udało się edytować osoby!');
                     })
                    .finally(function () {
                        self.editable = true;
                    });
            }
        },
        setRolesToChoose() {
            if (this.current_project === 'PROLIB' || this.current_project === 'QUATRA') {
                if (this.editParams.library_id !== this.sbs_id) {
                    this.rolesToChoose = this.roles;
                }
            } else if (this.current_project === 'ORACLE') {
                if (this.editParams.library_id === this.sbs_id) {
                    this.rolesToChoose = this.admin_roles;
                } else {
                    this.rolesToChoose = this.customer_roles;
                }
            }
        },
        listenForUploadImageSuccess() {
            EventBus.$on(this.personImageComponentName + '_upload_image_success', (value) => {
                this.editParams.photo = value.image;
            });
        },
        listenForDeleteImageSuccess() {
            EventBus.$on(this.personImageComponentName + '_delete_image_success', () => {
                this.editParams.photo = null;
            });
        }
    },
    watch: {
        person: {
            deep: true,
            handler() {
                if (this.person !== null) {
                    this.validationErrors = [];
                    this.editParams.id = this.person.id;
                    this.editParams.forename = this.person.name;
                    this.editParams.surname = this.person.surname;
                    this.editParams.email = this.person.email;
                    this.editParams.phone = this.person.phone;
                    this.editParams.consultant = this.person.consultant;
                    this.editParams.programmer = this.person.programmer;
                    this.editParams.installation = this.person.installation;
                    this.editParams.designer = this.person.designer;
                    this.editParams.to_contact = this.person.to_contact;
                    this.editParams.active = this.person.active;
                    this.editParams.library_id = this.person.library_id;
                    this.editParams.role_id = this.person.role_id;
                    this.editParams.jira_username = this.person.jira_username;
                    this.editParams.login = this.person.login;
                    this.editParams.password = '';
                    this.editParams.photo = this.person.photo;
                    this.setRolesToChoose();
                }
            }
        },
        editParams: {
            deep: true,
            handler() {
                if (!this.editParams.consultant && !this.editParams.installation) {
                    this.editParams.to_contact = false;
                }
            }
        }
    },
}
</script>
